export const GET_DOCUMENTS = 'getDocuments';
export const SEND_FILES = 'sendFiles';
export const CREATE_PROOF_PAY = "createProofPay"
export const LOADER = 'loader';
export const PROCESS_ID = 'processId'
export const GET_PROCESS = 'getProcess';
export const HAS_FILE_PENDING = 'hasFilePending';